export default class ExportCheckController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/exportCheck/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/exportCheck/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/exportCheck/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/exportCheck/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/exportCheck/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/exportCheck/delete', 'post', params, axiosOption, httpOption);
  }
  static listDict (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/exportCheck/listDict', 'get', params, axiosOption, httpOption);
  }
}
